import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Layout from './layouts/Layout';
import AppRoutes from './routes';
import { CartProvider } from './shared/context/CartContext';
import api from './shared/utils/request';
import './App.css';

function App() {
  useEffect(() => {
    const fcmToken = window.fcmToken;
    const userToken = localStorage.getItem('token');

    if (fcmToken && userToken) {
      api.post('customer/update-fcm-token', { fcm_token: fcmToken });
    }
  }, []);

  return (
    <BrowserRouter>
      <CartProvider>
        <Layout>
          <AppRoutes />
        </Layout>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
